export enum API_KEY_STATUS {
  ENABLE = 'Enable',
  DISABLE = 'Disable',
  INACTIVE = 'Inactive',
}
